import React, { useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import "./AppTopbar.scss";
import { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "./ContextHook/AppContext";
import { useDispatch, useSelector } from "react-redux";
import { Avatar } from "primereact/avatar";
import profileImage from "./assets/imgs/dummy-img.png";
import { classNames } from "primereact/utils";
import { OverlayPanel } from "primereact/overlaypanel";
import { Menubar } from "primereact/menubar";
import LogoDark from "./assets/imgs/logo2.png";
import LogoLight from "./assets/imgs/logo_light.svg";
import { Menu } from "primereact/menu";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { ListBox } from "primereact/listbox";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { LOGIN_SUCCESS } from "./redux/slices/authenticationSlice";
import { handlePostRequest } from "./services/PostTemplate"; // Import the API request function
import { getSocket, SOCKET_ENDPOINTS } from "./services/Socket"; // Import the socket service

export const AppTopbar = (props) => {
    const selectedUserType = useSelector((state) => state?.authenticationSlice?.selectedUserType);
    const userType = useSelector((state) => state?.authenticationSlice?.userType);
    const username = useSelector((state) => state?.authenticationSlice?.username);
    const [visible, setVisible] = useState(false);
    const location = useLocation();
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const dispatch = useDispatch();
    const menuRef = useRef(null);
    const notificationRef = useRef(null);
    const passengerMenuItem = [
        {
            label: "Profile",
            icon: "pi pi-spin pi pi-fw pi-cog",
            command: () => history.push("/profile-detail"),
        },

        {
            label: "Schedules",
            icon: "pi pi-car",
            command: () => history.push("/schedules"),
        },
        {
            label: "Payment",
            icon: "pi pi-money-bill",
            command: () => history.push("/payment"),
        },
        {
            label: "Wallet",
            icon: "pi pi-wallet",
            command: () => history.push("/wallet"),
        },
        {
            label: "Corporate",
            icon: "pi pi-briefcase",
            command: () => history.push("/corporate"),
        },
        {
            label: "Spinng Game",
            icon: "pi pi-spin pi pi-spinner",
            command: () => history.push("/game"),
        },
        {
            label: "Support",
            icon: "pi pi-thumbs-up",
            command: () => history.push("/support"),
        },
        {
            label: "Invite Friends",
            icon: "pi pi-user",
            command: () => history.push("/invite-friends"),
        },
        {
            label: "Tutorials",
            icon: "pi pi-user",
            command: () => history.push("/tutorials"),
        },
        {
            label: "Logout",
            icon: "pi pi-sign-out",
            command: () => handleLogOut(),
        },
    ];
    const ownerMenuItem = [
        {
            label: "Profile",
            icon: "pi pi-spin pi pi-fw pi-cog",
            command: () => history.push("/profile-detail"),
        },
        {
            label: "Schedules",
            icon: "pi pi-car",
            command: () => history.push("/schedules"),
        },
        {
            label: "Wallet",
            icon: "pi pi-wallet",
            command: () => history.push("/wallet"),
        },
        {
            label: "Corporate",
            icon: "pi pi-briefcase",
            command: () => history.push("/corporate"),
        },
        {
            label: "Spinng Game",
            icon: "pi pi-spin pi pi-spinner",
            command: () => history.push("/game"),
        },
        {
            label: "Support",
            icon: "pi pi-thumbs-up",
            command: () => history.push("/support"),
        },

        // owners
        {
            label: "Vehicle",
            icon: "pi pi-car",
            command: () => history.push("/vehicle-detail"),
        },
        {
            label: "Payment",
            icon: "pi pi-money-bill",
            command: () => history.push("/payment"),
        },
        {
            label: "Documents",
            icon: "pi pi-file",
            command: () => history.push("/documents"),
        },
        {
            label: "Invite Friends",
            icon: "pi pi-user",
            command: () => history.push("/invite-friends"),
        },
        {
            label: "Tutorials",
            icon: "pi pi-fw pi-cog",
            command: () => history.push("/tutorials"),
        },
        {
            label: "Logout",
            icon: "pi pi-sign-out",
            command: () => handleLogOut(),
        },
    ];
    const [selectedMenu, setSeletedMenu] = useState(selectedUserType === "1" ? ownerMenuItem : passengerMenuItem);

    const history = useHistory();

    const handleLogOut = () => {
        localStorage.clear();
        window.location.reload();
    };

    const showDropdown = (event) => {
        menuRef.current.toggle(event);
        setIsOpenMenu(!isOpenMenu);
    };

    const [notifications, setNotifications] = useState([]);
    const socket = getSocket();
    const userId = localStorage.getItem("userId");

    const showNotification = async (event) => {
        notificationRef.current.toggle(event);
        try {
            const response = await handlePostRequest("api/systemNotification", {}, true, true);
            const fetchedNotifications = response?.data?.notifications || [];
            console.log(fetchedNotifications);
            setNotifications(fetchedNotifications);

            const topic = userType === "1" ? "drivers" : userType === "2" ? "passengers" : "both";
            const params = {
                // topic: `development-${topic}`,
                topic: "development",
                userType: userType,
                userId: userId,
                page: 1,
            };

            socket.emit(`/topic?topic=${params.topic}-${params.userType}&userId=${params.userId}&page=${params.page}`, (response) => {
                console.log("Socket response:", response);
                // Handle the socket response if needed
            });
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    };
    const handleClose = (event) => {
        notificationRef.current.hide();
    };

    const handleCloseDialogBox = () => {
        if (!visible) return;
        setVisible(false);
    };

    const handleSwitchRole = () => {
        console.log(selectedUserType === "1");
        if (selectedUserType === "1") {
            localStorage.setItem("selectedUserType", "2");
            setVisible(false);
            window.location.reload();
        } else {
            localStorage.setItem("selectedUserType", "1");
            setVisible(false);
            window.location.reload();
        }
    };

    useLayoutEffect(() => {
        if (selectedUserType === "1") {
            setSeletedMenu(ownerMenuItem);
        } else {
            setSeletedMenu(passengerMenuItem);
        }
    }, [selectedUserType]);

    useLayoutEffect(() => {
        if (userType === "3") {
            let switchRole = {
                label: `Switch to ${selectedUserType === "1" ? "Passenger" : "Owner"}`,
                icon: "pi pi-sort-alt",
                command: () => setVisible(true),
            };
            passengerMenuItem.splice(1, 0, switchRole);
            ownerMenuItem.splice(1, 0, switchRole);
        }
    }, [userType]);

    return (
        <>
            <div className="layout-topbar">
                <div className="flex">
                    <button type="button" className=" block lg:hidden p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                        <i className="pi pi-bars" />
                    </button>
                    <Link to="/" className="layout-topbar-logo">
                        <img src={true ? LogoLight : LogoDark} alt="logo" />
                    </Link>
                </div>

                <div className="hidden lg:flex w-full h-full  justify-content-center align-items-center">
                    <span className={`topbar-menu-label ${location.pathname === "/" ? "active-link" : ""} `}>
                        <Link to="/">Book a Ride</Link>
                    </span>
                    <span className={`topbar-menu-label ml-3 ${location.pathname === "/my-ride" ? "active-link" : ""} `}>
                        <Link to="/my-ride">My Rides</Link>
                    </span>
                </div>

                <div className="pms-topbar">
                    <div className="flex align-items-center ">
                        <div>
                            {/* <i className="pi pi-fw pi-bell cursor-pointer" style={{ fontSize: "1.4rem" }} onClick={showNotification}></i> */}
                            <OverlayPanel ref={notificationRef}>
                                {notifications.length > 0 ? (
                                    notifications.map((notification, index) => (
                                        <div className="cursor-pointer notification" key={index} onClick={handleClose}>
                                            <p className="mb-0 px-1 py-3">{notification}</p>
                                            {index !== notifications.length - 1 && <hr className="my-0" />} {/* Add hr line between notifications */}
                                        </div>
                                    ))
                                ) : (
                                    <div className="cursor-pointer notification" onClick={handleClose}>
                                        <p className="mb-0 px-1 py-3">No Notification</p>
                                    </div>
                                )}
                            </OverlayPanel>
                        </div>
                        <i className="ml-4 lg:mx-4 pi pi-fw pi-question-circle cursor-pointer" style={{ fontSize: "1.4rem" }} onClick={() => history.push("/faq")}></i>
                        <div className="hidden lg:flex align-items-center cursor-pointer" onClick={showDropdown}>
                            <Avatar className="profile-image border-circle cursor-pointer mr-3" image={profileImage} size="large" shape="circle" />
                            <div>
                                <p className="mb-0 text-lg font-semibold">{username}</p>
                                <p className="text-base">{selectedUserType === "1" ? "Owner" : "Passenger"}</p>
                            </div>
                            <i className={`hidden lg:block pi pi-angle-up ${isOpenMenu ? "rotate-180" : ""} transition-duration-200 cursor-pointer ml-2`} style={{ fontSize: "1.4rem" }}></i>
                        </div>
                        <Menu className="hidden lg:block" model={selectedMenu} popup ref={menuRef} onHide={() => setIsOpenMenu(false)} onShow={() => setIsOpenMenu(!isOpenMenu)} />
                    </div>
                </div>
            </div>
            <Dialog className="surface-card" header="Confirmation" visible={visible} style={{ width: "25vw" }} onHide={handleCloseDialogBox}>
                <div>
                    <p className="text-center">Are you sure want to switch Account</p>
                    <div className="flex justify-content-center mt-5">
                        <Button label="Yes" onClick={handleSwitchRole} />
                        <Button label="Cancel" className="delete-btn ml-3" onClick={() => setVisible(false)} />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
